import React from "react";

import { Tabs, Tab, TabProps } from "@mui/material";
import { Link, LinkProps, useLocation } from "react-router-dom";

export const TabLink = ({ items }) => {
  const location = useLocation();
  return (
    <Tabs textColor="secondary" value={location.pathname}>
      {items &&
        items.map(({ label, to }, i, arr) => {
          // the first tab will be "active" if none of the other tabs match
          const behaveAsDefaultTab =
            i === 0 && arr.every(({ to }) => !(to === location.pathname));
          return (
            // MUI has not properly typed the Tab component, see
            // https://mui.com/material-ui/api/tab/#inheritance
            // @ts-ignore
            <Tab
              key={label}
              label={label}
              component={Link}
              value={behaveAsDefaultTab ? location.pathname : to}
              to={to}
            />
          );
        })}
    </Tabs>
  );
};

export type TabLinkProps = {
  /* Pages that the tabs will Link to */
  items: Array<{ label: TabProps["label"]; to: LinkProps["to"] }>;
};
